import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppService } from 'src/app/app.service';
import { WalletService } from 'src/app/pages/wallet/wallet.service';
import { IncomingData } from '../../interfaces/select-currency.interface';

/**
 * 选择法币弹窗
 */
@UntilDestroy()
@Component({
  selector: 'app-select-currency',
  templateUrl: './select-currency.component.html',
  styleUrls: ['./select-currency.component.scss'],
})
export class SelectCurrencyComponent implements OnInit, OnDestroy {
  constructor(
    private dialogRef: MatDialogRef<SelectCurrencyComponent>,
    private appService: AppService,
    private walletService: WalletService,
    @Inject(MAT_DIALOG_DATA)
    public data: IncomingData
  ) {}

  ngOnInit() {
    this.appService.openWalletSelectCurrency$.next({
      isOpen: true,
      from: this.data.from,
      isDigital: this.data.isDigital,
      showBalance: this.data.showBalance,
      isShowAllCurrencies: this.data.isShowAllCurrencies,
      isSelected: this.data?.isSelected || false,
      useData: this.data?.useData || null,
    });

    this.walletService.selectCurrencyEvent$.pipe(untilDestroyed(this)).subscribe(event => {
      if (event && event.from === this.data.from) {
        this.dialogRef.close(event.data);
      }
    });
  }

  ngOnDestroy() {
    this.appService.openWalletSelectCurrency$.next({ isOpen: false, isSelected: false });
  }
}
